import '@nimbus-ds/styles/dist/index.css';
import { FC } from 'react';

import { ToastProvider } from '@nimbus-ds/components';

import Appcues from 'commons/utils/appcues/appcues';
import Clarity from 'commons/utils/clarity/clarity';
import 'commons/utils/datadog/settings';
import useDatadogRecordRUM from 'commons/utils/datadog/useDatadogRecordRUM';
import { SidemodalsProvider } from 'commons/utils/hooks/useModal';

import Routes from './Routes/Router';

const App: FC = () => {
  useDatadogRecordRUM();

  return (
    <SidemodalsProvider>
      <ToastProvider>
        <Appcues />
        <Clarity />

        <Routes />
      </ToastProvider>
    </SidemodalsProvider>
  );
};

export default App;
